const options = (...labels) => labels.map(([value, label]) => ({ value, label }))
const textModes = options(
  ['exact', '精确匹配'],
  ['contains', '包含任一'],
  ['all', '包含全部'],
  ['none', '不含任一'],
  ['prefix', '前缀'],
  ['suffix', '后缀']
)
const yesNo = options(['', '全部'], [1, '是'], [0, '否'])
export const fields = [
  { key: 'category_id', label: '商品分类' },
  { key: 'status', label: '商品状态', options: options(['', '全部'], [3, '在售'], [4, '仓库中'], [6, '草稿']) },
  {
    key: 'title_mode',
    label: '标题匹配方式',
    options: options(['any', '包含任一'], ['all', '包含全部'], ['none', '不包含'])
  },
  { key: 'product_title', label: '标题关键词', placeholder: '多个关键词用逗号或空格分隔' },
  { key: 'platform_product_id', label: '抖店商品 ID', placeholder: '多个 ID 用逗号或空格分隔' },
  { key: 'stock', label: '库存范围（件）', range: true },
  {
    key: 'price_mode',
    label: '售价类型',
    options: options(['product', '商品售价'], ['all_skus', '所有 SKU 售价'], ['any_sku', '任一 SKU 售价'])
  },
  { key: 'price', label: '售价范围（元）', range: true },
  { key: 'created_at', label: '创建时间', date: true },
  { key: 'brand_id', label: '原品牌 ID' },
  { key: 'presell', label: '发货模式', options: options(['', '全部'], [0, '现货'], [1, '预售'], [2, '现货预售混合']) },
  { key: 'quality', label: '质量分', range: true },
  { key: 'freight_id', label: '运费模板 ID' },
  { key: 'is_distribute', label: '是否分销（本系统）', options: yesNo },
  { key: 'product_no_mode', label: '货号匹配方式', options: textModes },
  { key: 'product_no', label: '货号' },
  { key: 'sales', label: '销量范围（件）', range: true },
  { key: 'is_draft', label: '是否草稿', options: yesNo },
  { key: 'has_exposure', label: '最近 30 天是否曝光', options: yesNo },
  {
    key: 'sku_code_mode',
    label: 'SKU 编码匹配方式',
    options: options(['exact', '精确匹配'], ['contains', '包含匹配'], ['empty', '为空'])
  },
  { key: 'sku_code', label: 'SKU 编码' },
  {
    key: 'sku_name_mode',
    label: 'SKU 名称匹配方式',
    options: options(['exact', '精确匹配'], ['contains', '包含匹配'])
  },
  { key: 'sku_name', label: 'SKU 名称' },
  { key: 'fabric_material', label: '面料材质', placeholder: '材质属性值，执行时核验' },
  { key: 'has_video', label: '主图视频', options: yesNo, more: true },
  { key: 'quality_problem', label: '质量分问题代码', more: true },
  { key: 'source_shop_name', label: '来源店铺', more: true },
  { key: 'source_product_id', label: '来源 ID', more: true },
  { key: 'source_title', label: '来源标题', more: true }
]
export const pairedFields = {
  product_title: 'title_mode',
  price: 'price_mode',
  product_no: 'product_no_mode',
  sku_code: 'sku_code_mode',
  sku_name: 'sku_name_mode'
}
export const defaults = () =>
  fields.reduce((values, field) => {
    if (field.range) {
      values[field.key + '_min'] = ''
      values[field.key + '_max'] = ''
    } else
      values[field.key] =
        field.key === 'category_id'
          ? { level1: [], level2: [], level3: [] }
          : field.date
          ? []
          : field.options
          ? field.options[0].value
          : ''
    return values
  }, {})

// 普通字段由SQL筛选，其余字段由后台冻结后逐商品判断；此处只负责类型与选择范围。
export const buildBatchProductFilter = (values, shops, excluded, mode, selectedIds = []) => {
  const filter = { shop_ids: shops.map(Number), excluded_product_ids: [...excluded] }
  Object.keys(values).forEach((key) => {
    const value = values[key]
    if (value !== '' && value != null && !(Array.isArray(value) && !value.length))
      filter[key] = typeof value === 'object' ? JSON.parse(JSON.stringify(value)) : value
  })
  if (filter.platform_product_id)
    filter.platform_product_id = [
      ...new Set(
        String(filter.platform_product_id)
          .split(/[,，\s]+/)
          .filter(Boolean)
      )
    ]
  if (mode === 'goods' || mode === 'products') {
    delete filter.status
    delete filter.created_at
    delete filter.category_id
    filter.platform_product_id = [...new Set(selectedIds.map(String))]
  }
  Object.keys(filter)
    .filter((key) => /_(min|max)$/.test(key))
    .forEach((key) => {
      filter[key] = Number(filter[key])
    })
  return filter
}
